//@flow
import {useCallback, useMemo} from 'react';
import {useSelector, shallowEqual} from 'react-redux';

import {useActions} from '../../../utils/globalStore';
import {actions as onboardingActions} from '../duck';

import type {RootState} from '../../';

const onBoardingInformationSelector = (state: RootState) => ({
  goalInformation: state.onBoarding.goalInformation,
  supportInformation: state.onBoarding.supportInformation,
});

export function useOnboardingInformation() {
  const {goalInformation, supportInformation} = useSelector(
    onBoardingInformationSelector,
    shallowEqual
  );
  return {
    goalInformation,
    supportInformation,
  };
}

const onboardingActionsSelector = {
  getGoalInformation: onboardingActions.getGoalInformation,
  getSupportInformation: onboardingActions.getSupportInformation,
};

export function useOnboardingInformationActions() {
  const {getGoalInformation, getSupportInformation} = useActions(
    onboardingActionsSelector
  );

  const _getGoalInformation = useCallback(() => {
    getGoalInformation();
  }, [getGoalInformation]);

  const _getSupportInformation = useCallback(() => {
    getSupportInformation();
  }, [getSupportInformation]);

  return useMemo(
    () => ({
      getGoalInformation: _getGoalInformation,
      getSupportInformation: _getSupportInformation,
    }),
    [_getGoalInformation, _getSupportInformation]
  );
}
